module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sendPoints"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("./1-1.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "qr"
  }, [_c('div', [_vm._v("立即下载东航期货APP开户")]), _vm._v(" "), _c('div', [_vm._v("参赛后，领取很多积分奖励")]), _vm._v(" "), _c('img', {
    staticClass: "qrcode",
    attrs: {
      "src": require("./qr.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_vm._v("APP首页点击“"), _c('span', {
    staticClass: "color"
  }, [_vm._v("蓝海密剑")]), _vm._v("”板块")]), _vm._v(" "), _c('div', [_vm._v("选择“"), _c('span', {
    staticClass: "color"
  }, [_vm._v("报名参赛")]), _vm._v("”即可获取积分")])]), _vm._v(" "), _c('img', {
    staticClass: "end",
    attrs: {
      "src": require("./1-2.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7044994e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/sendPoints/success.vue
// module id = 897
// module chunks = 2